import router from "../router/index";

export const userModule = {
    state: () => ({
        role: null
    }),
    mutations: {
        setRole(state, newValue) {
            state.role = newValue;
        }
    },
    actions: {
        setUserData({ commit }, data) {
            commit("setRole", data?.role);
            const { blocked, confirmed, createdAt, updatedAt, provider, ...converted } = data;
            sessionStorage.setItem("user", JSON.stringify(converted));
            router.push("/platform/cotizador");
        }
    }
}